<template>
  <div class="container" style="margin-top: 20px">
    <h1>
      Over de app
    </h1>
    <p>Deze app is gemaakt door Steve Jonk om meer met Vue.js te oefenen</p>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/over.vue